export default {
  list: {
    title: "Actividades",
    descriptionAdmin: "Ver y crear actividades para vendedores y anfitriones",
    descriptionPartner: "Gestione sus actividades, servicios y ofertas",
    newActivity: "Nueva actividad",
    loading: "Cargando actividades...",
    emptyTitle: "No hay actividades",
    emptyDescription: "Aún no tiene actividades.",
    emptyDescriptionAdmin:
      "Cree una actividad para un vendedor o anfitrión para empezar.",
    createFirst: "Crear primera actividad",
    createdToast: "¡Actividad creada correctamente!",
    errorLoad: "No se pudieron cargar las actividades",
    filterAria: "Filtrar actividades",
    filterAll: "Todas",
    filterVisible: "Visibles",
    filterHidden: "Ocultas",
    searchPlaceholder: "Buscar por nombre o ciudad…",
    noMatchesTitle: "Ninguna actividad coincide",
    noMatchesDescription: "Prueba otra búsqueda o muestra todas las actividades.",
    showAll: "Mostrar todas",
  },
  detail: {
    updatedToast: "¡Actividad actualizada correctamente!",
    serviceCategoriesUpdated: "Categorías de servicio actualizadas",
    back: "Volver a actividades",
    goToPartner: "Ir al partner",
    staffPanelTitle: "Controles de staff",
    adminEditingBanner:
      "Estás editando este escaparate como staff. Los cambios se aplican al anuncio publicado del vendedor.",
    adminCommissionTitle: "Comisión de la plataforma",
    adminOnlyBadge: "Solo staff",
    adminCommissionHint:
      "Porcentaje que retiene la plataforma en las reservas de esta actividad. Los vendedores no ven esta sección.",
    adminCommissionPercentAria: "Porcentaje de comisión para esta actividad",
    adminCommissionPercentInvalid: "Introduzca un porcentaje válido.",
    adminCommissionEdit: "Cambiar",
    adminCommissionToastSaved: "Comisión actualizada.",
    adminCategoryTitle: "Tipo de actividad",
    adminCategoryHint:
      "Si este listado es un restaurante, una atracción o un servicio. Los vendedores no pueden cambiarlo.",
    adminCategoryToastSaved: "Tipo de actividad actualizado.",
    adminSalesAgentTitle: "Agente comercial",
    adminSalesAgentEmpty: "Sin asignar",
    adminSalesAgentChange: "Cambiar",
    adminSalesAgentAssign: "Asignar",
    adminSalesAgentToastSaved: "Asignación del agente actualizada.",
    adminSalesAgentPercentInvalid:
      "Introduzca un porcentaje de comisión válido.",
    adminSalesAgentModalAssignTitle: "Asignar agente",
    adminSalesAgentModalReassignTitle: "Cambiar agente",
    adminPromoTitle: "Descuento promocional",
    adminPromoActive: "Activo",
    adminPromoEnabled: "Promoción activada",
    adminPromoHint:
      "Define el margen mínimo que la plataforma conserva en esta actividad. El descuento sale íntegramente del margen de la plataforma, por lo que las demás partes cobran como si no hubiera descuento. El descuento real varía según el artículo y la estructura.",
    adminPromoMarginMode: "Modo de margen mínimo",
    adminPromoMarginModeAbsolute: "Importe fijo",
    adminPromoMarginModePercentage: "Porcentaje del margen máximo",
    adminPromoMarginValueAbsolute: "Margen mínimo de la plataforma (€)",
    adminPromoMarginValuePercentage: "Margen mínimo (% del máximo)",
    adminPromoItemColumn: "Artículo",
    adminPromoPreviewHint:
      "Los descuentos varían según el artículo y la estructura. Las cifras de abajo son por artículo en todas las estructuras alcanzables.",
    adminPromoPreviewLoading: "Cargando datos de vista previa…",
    adminPromoNoItems:
      "Añade artículos al catálogo para previsualizar los descuentos resultantes.",
    adminPromoMaxMargin: "Margen máx.",
    adminPromoMinDiscount: "Descuento mín.",
    adminPromoMedianDiscount: "Descuento mediano",
    adminPromoMaxDiscount: "Descuento máx.",
    adminPromoOverrideColumn: "Anulación",
    adminPromoAddOverride: "Anular",
    adminPromoRemoveOverride: "Quitar anulación",
    adminPromoSave: "Guardar promoción",
    adminPromoRemove: "Quitar promoción",
    adminPromoToastSaved: "Promoción guardada.",
    adminPromoToastRemoved: "Promoción eliminada.",
    headerCommission: "Comisión {{percent}}",
    openStaffTab: "Abrir ajustes de staff",
    adminActiveTitle: "Actividad activa",
    adminSalesAgentHint: "Agente que trajo esta actividad y su comisión.",
    adminPromoNotConfigured: "Sin configurar",
    adminPromoPaused: "En pausa",
    adminPromoPreviewTitle: "Vista previa de descuentos por artículo",
    adminPromoPreviewEmpty: "Introduce un margen mínimo válido arriba para calcular el descuento de cada artículo.",
    adminPromoPreviewError: "No se ha podido calcular la vista previa de descuentos. Inténtalo de nuevo en un momento.",
    adminPromoPriceColumn: "Precio",
    adminPromoOverrideCount_one: "{{count}} excepción",
    adminPromoOverrideCount_other: "{{count}} excepciones",
    adminCatalogImportTitle: "Importar catálogo desde PDF",
    adminCatalogImportBarHint:
      "Extrae artículos y etiquetas de un PDF (también escaneado) y revísalos.",
    adminCatalogImportOpen: "Importar PDF",
    adminCatalogImportHint:
      "Suba un PDF de menú o catálogo — digital o escaneado. Revise primero las etiquetas y asígnelas a los artículos con el desplegable. Las etiquetas se guardan en la actividad al confirmar.",
    adminCatalogImportFileLabel: "Solo PDF",
    adminCatalogImportDropHint: "Haga clic para elegir un PDF",
    adminCatalogImportExtract: "Extraer artículos",
    adminCatalogImportSave: "Guardar artículos",
    adminCatalogImportCancel: "Descartar",
    adminCatalogImportChooseAnother: "Elegir otro PDF",
    adminCatalogImportPreviewCount: "{{count}} artículo(s) para revisar",
    adminCatalogImportLabelsTitle: "Etiquetas",
    adminCatalogImportLabelsHint:
      "Del PDF y de esta actividad. Renombrar actualiza todos los artículos vinculados. Puede añadir nuevas en cualquier momento.",
    adminCatalogImportLabelsEmpty:
      "Aún no hay etiquetas. Añada una para asignarla a los artículos.",
    adminCatalogImportAddLabelPlaceholder: "Nombre de la nueva etiqueta",
    adminCatalogImportRemoveLabel: "Quitar etiqueta",
    adminCatalogImportLabelNameRequired: "Cada etiqueta necesita un nombre.",
    adminCatalogImportLabelDuplicate: "Esa etiqueta ya existe.",
    adminCatalogImportLabelMissing:
      "Un artículo apunta a una etiqueta eliminada.",
    adminCatalogImportLabelUntitled: "(sin nombre)",
    adminCatalogImportName: "Nombre",
    adminCatalogImportCategory: "Etiqueta",
    adminCatalogImportCategoryNone: "Sin etiqueta",
    adminCatalogImportDescription: "Descripción",
    adminCatalogImportPrice: "Precio (€)",
    adminCatalogImportRemoveRow: "Quitar artículo",
    adminCatalogImportPickFile: "Elija primero un archivo PDF.",
    adminCatalogImportEmptyPreview:
      "No hay artículos para guardar. Extraiga de nuevo o descarte.",
    adminCatalogImportNameRequired: "Cada artículo necesita un nombre.",
    adminCatalogImportPriceInvalid: "Introduzca un precio válido no negativo.",
    adminCatalogImportTranslatedBanner:
      "El texto se tradujo a {{language}} para revisión. Idioma detectado: {{source}}.",
    adminCatalogImportToastExtracted:
      "Se extrajeron {{count}} artículo(s). Revise antes de guardar.",
    adminCatalogImportToastSaved:
      "Se añadieron {{count}} artículo(s) al catálogo.",
    visibilityLabel: "Visibilidad en el catálogo",
    visibilityHint:
      "Encendido: visible en el catálogo cuando la actividad está activa. Apagado: oculta, sin nuevas reservas. Guardar para aplicar.",
    visibilityToggleAria: "Mostrar u ocultar esta actividad en el catálogo",
    visibilityLockedHint:
      "Complete su perfil legal en Ajustes antes de poder hacer visible esta actividad.",
    adminActiveHint:
      "Solo staff. Si está desactivada, los partners no pueden abrirla y nunca aparece en el catálogo.",
    adminActiveToggleAria: "Activar o desactivar esta actividad (staff)",
    adminActiveToastSaved: "Estado activo de la actividad actualizado.",
    profileIncompleteBanner:
      "Su perfil legal está incompleto. Esta actividad no puede aparecer en el catálogo de clientes hasta que complete su perfil.",
    profileIncompleteModalTitle: "Complete su perfil legal",
    profileIncompleteModalMessage:
      "Esta actividad no puede mostrarse a los clientes hasta que complete su perfil legal. Vaya a Ajustes para rellenar la información requerida o continúe editando y complete el perfil más tarde.",
    profileIncompleteModalGoToProfile: "Ir al perfil",
    profileIncompleteModalLater: "Más tarde",
    partnerShareBadge: "{{percent}}% por reserva",
    partnerShareHint:
      "Cuota acordada con Flitrip en cada reserva de esta actividad.",
    untitledActivity: "Actividad sin título",
    loading: "Cargando actividad...",
    notFoundMessage:
      "La actividad solicitada no existe o no tiene permisos para verla.",
    inactiveAdminBanner:
      "Esta actividad está inactiva. Los partners la ven en su lista pero no pueden abrirla hasta que la active.",
    hiddenBanner:
      "Esta actividad está oculta del catálogo. Active la visibilidad y guarde para mostrarla de nuevo.",
    tabs: {
      ariaLabel: "Secciones de configuración de la actividad",
      general: "General",
      generalDesc: "Nombre, ubicación y medios",
      generalHeading: "General y escaparate",
      generalHint:
        "Nombre y descripción en todos los idiomas admitidos, ubicación, imágenes y ajustes. Guarde los cambios de perfil con la barra inferior.",
      availability: "Disponibilidad",
      availabilityDesc: "Horario semanal y excepciones",
      availabilityHeading: "Disponibilidad",
      availabilityHint:
        "Configure franjas horarias semanales y excepciones para festivos o periodos especiales. Los cambios se guardan al instante.",
      configuration: "Configuración",
      configurationDesc: "Ajustes, menú y servicios",
      configurationHeading: "Configuración de la actividad",
      configurationHint:
        "Ajustes según categoría, platos del menú o catálogo de servicios. La mayoría de cambios se guardan al confirmarlos.",
      preview: "Vista previa",
      previewDesc: "Escaparate en tablet",
      previewHeading: "Vista previa del escaparate",
      previewHint:
        "Vea cómo aparece esta actividad en la tablet del local. Las acciones de reserva están deshabilitadas en la vista previa.",
      staff: "Staff",
      staffDesc: "Comisión, agente y promo",
      staffHeading: "Ajustes de staff",
      staffHint: "Solo visibles para el staff. Cada bloque se guarda por separado.",
    },
    preview: {
      title: "Vista previa del escaparate",
      disclaimer:
        "Esta es una vista previa de solo lectura de la página pública del catálogo. Guarde los cambios del perfil en otras pestañas antes de comprobar las actualizaciones aquí.",
      openInNewTab: "Abrir en una nueva pestaña",
    },
  },
  detailForm: {
    catalogCopyTitle: "Nombre y descripción",
    descriptionTitle: "Descripción",
    nameTitle: "Nombre",
    nameLanguageCardAria: "Editar nombre en {{language}}",
    descriptionPlaceholder:
      "Describa su actividad, los servicios ofrecidos y las experiencias que pueden esperar los clientes...",
    descriptionHint:
      "Opcional mientras redacta; obligatoria en todos los idiomas antes de hacerla visible",
    descriptionCustomerBanner:
      "Los clientes ven los textos del catálogo en su idioma cuando el nombre y la descripción están completos en todos los idiomas admitidos.",
    descriptionLanguageCardAria: "Editar descripción en {{language}}",
    autoTranslateHint:
      "El nombre y la descripción son obligatorios en todos los idiomas (inglés, español, italiano, alemán). Rellene al menos un idioma y genere las traducciones. Tras un cambio de nombre, genere de nuevo para actualizar los demás idiomas.",
    autoTranslateGenerate: "Generar traducciones",
    locationTitle: "Ubicación",
    handshakeConfigTitle: "Confirmación de reserva",
    requiresHandshake: "Requiere handshake",
    requiresHandshakeHint:
      "Si está activado, las reservas requieren confirmación del vendedor antes de finalizarse. Los clientes seleccionarán una fecha/hora preferida y esperarán su aprobación.",
    noteStrong: "Nota:",
    handshakeNote:
      "Los servicios de esta actividad usarán el horario de apertura de la actividad para la programación. Los clientes solo pueden tener un handshake activo a la vez.",
    handshakeNoteRestaurant:
      "Los clientes deben confirmar la reserva contigo antes de que se cobre la tasa de reserva. Los clientes solo pueden tener un handshake activo a la vez.",
    bookingCutoffTitle: "Cierre de reservas",
    bookingCutoffHint:
      "Cuánto antes del inicio de cada franja sin hora de fin deben cerrarse las reservas. Las franjas con hora de fin siguen reservables hasta ese fin (el cutoff no aplica).",
    bookingCutoffLeadTime: "Antelación",
    bookingCutoffUnitLabel: "Unidad",
    bookingCutoffUnitMinutes: "minutos",
    bookingCutoffUnitHours: "horas",
    bookingCutoffExample:
      "Ejemplo: franja de las 09:00 con 2 horas de antelación — se puede reservar hasta las 07:00; después ya no está disponible.",
  },
  weekdays: {
    monday: "Lunes",
    tuesday: "Martes",
    wednesday: "Miércoles",
    thursday: "Jueves",
    friday: "Viernes",
    saturday: "Sábado",
    sunday: "Domingo",
  },
  schedule: {
    title: "Horario de disponibilidad",
    weeklyTitle: "Horario semanal",
    overridesTitle: "Excepciones de horario",
    addOverride: "Añadir excepción",
    noOverrides:
      "Sin excepciones. Añada una para festivos o periodos especiales.",
    noSlotsClosed: "Sin franjas (cerrado)",
    addTimeSlot: "Añadir franja horaria",
    copyScheduleTitle: "Copiar horario del {{day}}",
    pasteScheduleTitle: "Pegar aquí el horario del {{day}}",
    deleteOverrideConfirm: "¿Eliminar esta excepción?",
    closedBadge: "Cerrado",
    slotModal: {
      editTitle: "Editar franja horaria",
      addTitle: "Añadir franja horaria",
      startRequired: "La hora de inicio es obligatoria",
      startTimeLabel: "Hora de inicio",
      duplicateStartError: "Otra franja ya usa esta hora de inicio",
      startOnlyTitle: "Hora de inicio",
      startOnlySubtitle: "Un único horario",
      startOnlyHint:
        "Los clientes pueden reservar esta franja hasta la hora de inicio. Si hay un cutoff, se cierra esos minutos antes del inicio.",
      windowTitle: "Franja horaria",
      windowSubtitle: "Inicio y fin",
      windowHint:
        "Los clientes pueden reservar esta franja hasta la hora de fin. El cutoff no se aplica.",
      endTimeLabel: "Hora de fin",
      endRequired: "La hora de fin es obligatoria en una franja con intervalo",
      endAfterStart: "La hora de fin debe ser posterior a la de inicio",
      overlapWarning:
        "Esta franja se solapa con otra. Aun así puedes guardarla.",
      maxCapacityLabel: "Aforo máximo (opcional)",
      maxCapacityPlaceholder: "Dejar vacío para ilimitado",
      maxCapacityHint: "Número máximo de plazas en esta franja",
      mealTypeLabel: "Tipo de comida (opcional)",
      breakfast: "Desayuno",
      lunch: "Comida",
      dinner: "Cena",
      aperitif: "Aperitivo",
      saveSlot: "Guardar cambios",
      addSlot: "Añadir franja",
    },
    overrideModal: {
      titleAdd: "Añadir excepción de horario",
      titleEdit: "Editar excepción",
      nameLabel: "Nombre",
      namePlaceholder: "p. ej., vacaciones de Navidad",
      from: "Desde",
      to: "Hasta",
      status: "Estado",
      closedDuring: "Cerrado durante este periodo",
      markClosed: "Marcar como cerrado",
      timeSlots: "Franjas horarias",
      addSlot: "Añadir franja",
      noSlotsHint:
        "Sin franjas definidas. Si está vacío, se usa el horario semanal.",
      saveChanges: "Guardar cambios",
      addOverrideBtn: "Añadir excepción",
      nameDateRequired: "El nombre y el rango de fechas son obligatorios",
      endAfterStart: "La fecha de fin debe ser posterior a la de inicio",
    },
    toast: {
      updated: "Horario actualizado",
      updateError: "Error al actualizar el horario",
      overrideCreated: "Excepción creada",
      overrideCreateError: "Error al crear la excepción",
      overrideUpdated: "Excepción actualizada",
      overrideUpdateError: "Error al actualizar la excepción",
      overrideDeleted: "Excepción eliminada",
      overrideDeleteError: "Error al eliminar la excepción",
      copiedDay: "Horario del {{day}} copiado",
      slotOverlapWarning:
        "Esta franja se solapa con otra. Se ha guardado de todos modos.",
    },
  },
  zod: {
    nameRequired: "El nombre es obligatorio en todos los idiomas",
    descriptionRequired: "La descripción es obligatoria en todos los idiomas",
    allTranslationsRequired:
      "Las traducciones son obligatorias en todos los idiomas",
    commissionPercentRequired: "La comisión de plataforma es obligatoria",
    commissionPercentRange: "Introduzca un porcentaje válido.",
    categoryRequired: "Seleccione una categoría del catálogo",
    paymentModelRequired: "Seleccione un tipo de pago",
    bookingCutoffInvalid: "Introduzca un número entero (0 o mayor).",
    bookingCutoffRange:
      "La antelación debe estar dentro de los límites permitidos (hasta 7 días).",
  },
  card: {
    active: "Activa",
    inactive: "Inactiva",
    hidden: "Oculta",
    notReadyYet: "Aún no lista",
    inactiveBlocked:
      "Esta actividad aún no está activa. Inténtelo de nuevo más tarde.",
    partnerShare: "{{percent}}% por reserva",
  },
  header: {
    paymentModelUpfront: "Pago por adelantado",
    paymentModelReceiptBased: "Con ticket",
  },
  createModal: {
    title: "Crear nueva actividad",
    owner: "Propietario",
    regionLabel: "Región de pago *",
    chooseRegion: "Seleccionar región…",
    regionRequired: "Selecciona una región de pago",
    searchOwnerLabel: "Buscar vendedor o anfitrión",
    searchOwnerPlaceholder: "Escriba para filtrar…",
    selectAccount: "Seleccionar cuenta *",
    chooseOwner: "Elegir propietario…",
    noOwnersError: "Añada primero un vendedor o anfitrión",
    partnerSuffix: "(vendedor)",
    hostSuffix: "(anfitrión)",
    catalogCategory: "Categoría del catálogo",
    activityName: "Nombre de la actividad",
    description: "Descripción",
    descriptionPlaceholder: "Describa su actividad...",
    location: "Ubicación",
    commissionPercentLabel: "Comisión de la plataforma (%)",
    salesAgent: "Agente comercial (contrato)",
    salesAgentSearchPlaceholder: "Escriba un correo…",
    salesAgentNoResults: "Ningún agente coincide con la búsqueda.",
    paymentModel: "Tipo de pago",
    paymentModelUpfront: "Pago por adelantado",
    paymentModelUpfrontDesc: "Los clientes pagan antes de la visita.",
    paymentModelReceiptBased: "Con ticket (flujo restaurante)",
    paymentModelReceiptBasedDesc:
      "Flujo tipo restaurante con carga de ticket y cashback.",
    createActivity: "Crear actividad",
    wizardNext: "Continuar",
    wizardSkip: "Omitir",
    wizardStepDetails: "Detalles",
    wizardStepSalesAgent: "Agente comercial",
    wizardStepCounter: "Paso {{current}} de {{total}}",
    withoutLocation: "Sin ubicación",
    noLocationSelectedMessage: "Esta actividad no tiene ubicación.",
    wizardStep2Lead:
      "Seleccione un agente de la lista, u omita para continuar sin agente.",
    salesAgentCutPercentLabel: "Comisión del agente (%)",
    salesAgentCutRequired:
      "Introduzca la comisión del agente cuando seleccione uno.",
    wizardStep3Lead:
      "Introduzca una dirección para geocodificar, o marque la actividad sin ubicación fija.",
    salesAgentListEmpty: "No hay agentes disponibles.",
  },
  adminCreate: {
    back: "Volver a actividades",
    backToPartner: "Volver al vendedor",
    backToHost: "Volver al anfitrión",
  },
  restaurantConfig: {
    title: "Configuración del restaurante",
    cuisineTypes: "Tipos de cocina",
    cuisinePlaceholder: "Seleccione tipos de cocina…",
    cuisineHint: "Seleccione uno o más tipos de cocina",
    avgPriceLabel: "Precio medio por persona (€)",
    avgPriceHint: "Coste medio por persona en euros",
    avgPricePlaceholder: "25",
  },
  serviceCategories: {
    title: "Categorías de servicio",
    addCategory: "Añadir categoría",
    emptyTitle: "Aún no hay categorías",
    emptyDescription: "Cree categorías para organizar los servicios que ofrece",
    emptyTitleMenu: "Las secciones estándar están listas",
    emptyDescriptionMenu:
      "Entrantes, primeros y el resto de platos predeterminados siguen disponibles al añadir platos. Añada una categoría aquí solo si necesita un agrupamiento extra.",
    standardCoursesHint:
      "Los platos predeterminados del menú siguen disponibles al añadir platos.",
    edit: "Editar categoría",
    delete: "Eliminar categoría",
    modalEditTitle: "Editar categoría",
    modalAddTitle: "Añadir categoría",
    nameLabel: "Nombre de la categoría",
    namePlaceholder: "p. ej. Masajes",
    saveChanges: "Guardar cambios",
    allTranslationsRequired: "El nombre es obligatorio en todos los idiomas",
    fillOneLanguageFirst:
      "Introduzca el nombre de la categoría en al menos un idioma antes de generar traducciones.",
    autoTranslateHint:
      "El nombre de la categoría es obligatorio en todos los idiomas. Rellene al menos un idioma y genere las traducciones. Tras un cambio de nombre, genere de nuevo para actualizar los demás idiomas.",
    autoTranslateGenerate: "Generar traducciones",
    thisCategory: "esta categoría",
    deleteConfirm: "¿Eliminar «{{name}}»?",
  },
  media: {
    saveChangesError: "No se pudieron guardar los cambios de medios",
    uploadedCount: "{{count}} archivo(s) subido(s)",
    deleted: "Medio eliminado",
    deleteFailed: "Error al eliminar el archivo",
    arrowNavHint: "Use las flechas ← → para navegar",
    prevTitle: "Anterior (←)",
    nextTitle: "Siguiente (→)",
    deleteConfirmTitle: "¿Eliminar el medio?",
    deleteConfirmMessage:
      "El archivo se eliminará de la actividad. Esta acción no se puede deshacer.",
    sectionTitle: "Imágenes y vídeos",
    autoSaveBadge: "Se guarda automáticamente",
    sectionDescription:
      "Suba imágenes y vídeos que se mostrarán a los clientes. Arrastre las miniaturas para reordenar.",
    emptyEditableTitle: "Añadir imágenes o vídeos",
    emptyEditableHint: "Haga clic para seleccionar archivos",
    emptyReadOnly: "No hay medios disponibles",
    thumbnailAlt: "Miniatura {{n}}",
    uploadingAlt: "Subiendo {{n}}",
    cropDescription:
      "Encuadre la foto para la galería del tablet (16:9). El centro discontinuo muestra lo que conservan las tarjetas de inicio (4:3).",
  },
} as const;
